import { render, staticRenderFns } from "./DonorWall.vue?vue&type=template&id=3ea4fed8"
import script from "./DonorWall.vue?vue&type=script&lang=js"
export * from "./DonorWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports